<template>
	<page-content-layout class="products" title="Produkter">
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view @itemClick="itemClick" @delete="itemDelete" :columns="[
			{
				label: 'Label',
				name: 'alt_label',
				weight: 2
			},
			{
				label: 'Beskrivelse',
				name: 'label',
				weight: 4
			},
			{
				label: 'Varenummer',
				name: 'sku'
			},
			{
				label: 'Alt varenummer',
				name: 'alt_sku'
			},
			{
				label: 'Pris',
				name: 'price',
				filter: 'float',
				align: 'right'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="items" />
	</page-content-layout>
</template>

<script>
	import Product from '../windows/ProductWindow'
	import NewTableView from '../views/NewTableView'

	import { bus } from '../../bus'
 
    export default {
		components: {
			newTableView: NewTableView
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				

				this.$store.state.windowStack.push(Product, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				

				var contacts = this;

				this.$store.state.windowStack.push(Product, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/products/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemAction: function (name, id) {
				if (name == 'delete') {
					if (!confirm('Sure?')) return;

					

					var contacts = this;

					this.axios
						.delete('/products/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				contacts.items = null;

				this.axios
					.get('/products/')
					.then(function (r) {
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: null,
				actions: [{name: 'delete', label: 'Delete'}]
			};
		},
		mounted: function () {
			this.axios.put('/activity/products/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.new-table-view {
		width: 100%;
		height: 100%;
	}
</style>